import { useService } from 'solid-services'
import { useFilters } from '../state/filter'
import { ValuesCombobox } from './ValuesCombobox'

export default function ExchangeCombobox() {
  const { setExchanges, filters } = useService(useFilters)()

  return (
    <ValuesCombobox
      column="exchange"
      label="Exchanges"
      placeholder="Search exchanges..."
      selected={filters().exchanges}
      onChange={setExchanges}
    />
  )
}
